import WorkoutDaysSelector from './WorkoutDaysSelector';

export default WorkoutDaysSelector;
